<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">认领记录</li>
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="--关键字--"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <div>
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="认领日期"
          end-placeholder="认领日期"
          value-format="YYYY-MM-DD"
          @change="
            (value) => {
              if (value) state.params.create_time = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.create_time;
          "
        />
      </div>
      <el-select
        v-model="state.params.bank_received_type"
        placeholder="认领用途"
        style="width: 200px"
      >
        <el-option
          v-for="item in state.typeData"
          :key="item"
          :label="item.name"
          :value="item.name"
        />
      </el-select>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column label="状态" sortable="status" :min-width="120">
          <template #default="{ row }">
            <c_status
              arr-name="bankcollected_status"
              :value="row.status"
            ></c_status>
          </template>
        </el-table-column>
        <el-table-column
          prop="bank_received_type"
          label="认领用途"
          :formatter="$tab_TextFormat"
          :min-width="120"
        />
        <el-table-column
          prop="collect_amount"
          label="认领金额"
          :formatter="$tab_MoneyFormat"
          align="center"
          sortable="collect_amount"
          :min-width="120"
        >
          <template #default="{ row }">
            <c_money
              :value="row.collect_amount"
              style="margin: auto; font-weight: 600"
              :style="{ color: row.collect_amount < 0 ? '#f00' : '#080' }"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="bank_received_id"
          label="到账记录Id"
          align="center"
          :min-width="120"
        />
        <el-table-column
          prop="check_admin_name"
          label="认领人"
          :min-width="120"
        />
        <el-table-column
          prop="collect_remark"
          label="认领说明"
          :min-width="260"
        />
        <el-table-column
          prop="check_admin_name"
          label="更新人"
          :min-width="120"
        />
        <el-table-column prop="update_time" label="更新时间" :min-width="160" />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { bankcollected_other } from "@/http/bankcollected";
import { bankcollected_other_type } from "@/http/data";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      bankcollected_other_type().then((res) => {
        if (res.status == 200) {
          state.typeData = res.data.data?.list;
        }
      });
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      bankcollected_other(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
